import styled, { css } from 'styled-components';
import {
  DIALOG_TYPE,
  DOCUMENT_TYPE,
  DOC_FORMAT_CONFIG_VALUES,
  EDIT_FROM,
  MAC_OS_NAME,
  VIA_PARTNER,
  PO_EDIT_MODE,
  PRODUCT_TYPE,
  URLS
} from '../define/global';
import { useDispatch } from 'react-redux';
import { openDialog } from '../store/modules/dialog';
import { useDocInfoSliceSelector } from '../store/modules/docInfo';
import iconMore from '../img/ribbon_ico_home.png';
import iconMore2X from '../img/ribbon_ico_home@2x.png';
import iconDownload from '../img/ribbon_ico_download.png';
import iconDownload2X from '../img/ribbon_ico_download@2x.png';
import iconUpload from '../img/ribbon_ico_upload.png';
import iconUpload2X from '../img/ribbon_ico_upload@2x.png';
import iconShareLink from '../img/panel_ico_link.png';
import iconShareLink2X from '../img/panel_ico_link@2x.png';
import iconNotice from '../img/ribbon_ico_notice.png';
import iconNotice2X from '../img/ribbon_ico_notice@2x.png';
import iconUser from '../img/ribbon_ico_user.png';
import iconUser2X from '../img/ribbon_ico_user@2x.png';
import iconRename from '../img/ico_ctr_big_arrow_down.png';
import iconRename2X from '../img/ico_ctr_big_arrow_down@2x.png';
import iconUploadWorks from '../img/ico_works_16.png';
import iconUploadWorks2X from '../img/ico_works_16@2x.png';
import { useAppDataSliceSelector } from '../store/modules/appData';
import { Fragment, useCallback, useEffect, useState } from 'react';
import Button from './common/Button';
import { useTranslation } from 'react-i18next';
import { cssClearFix, cssFloatLeft, cssFloatRight, noTextSelect } from './common/CssCommon';
import ga from '../utils/gaConnect';
import { getFormatImg, isDevicePC, useUploadItt } from '../utils/util';
import { getUseFonts, setUseFonts } from '../utils/FontsUtil';
import { showFileMenu } from '../store/modules/popup';
import HeaderMobile from './common/mobile/HeaderMobile';
import { setMessage } from '../store/modules/extensionHandle';
import { MESSAGE_TYPE } from '../define/extension/message';
import { useDoFlowByDownload } from '../utils/FileControlUtil';
import { usePOWebofficeSDKState } from '../context/poWebOfficeSDKContext';
import { useNaverWorksDataSliceSelector } from '../store/modules/naverWorksData';

export const HEADER_CONTAINER_HEIGHT = 26;

const TitleMenu = styled.ul`
  margin: 0;
  display: flex;
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;
  list-style-type: none;
  height: 100%;
  margin-left: 20px;
  align-items: center;
  ${cssFloatRight};
`;

const TitleMenuItem = styled.li`
  & + & {
    margin-left: 12px;
  }
  /* height: 100%; */
  height: 22px;
  display: flex;
  align-items: center;
  border-radius: 2px;
  padding: 3px;
  box-sizing: border-box;
  ${({ cssExt }) => cssExt && cssExt}

  &:hover {
    background: #edeff0;
    cursor: pointer;
  }
  &:active {
    background: #e0e0e0;
  }
  ${noTextSelect}
`;

const TitleFileInfo = styled.div`
  ${cssFloatLeft}
  height:100%;
  display: flex;
  padding-top: 5px 0 5px 0;
  box-sizing: border-box;
  align-items: center;
  flex: 1;
  overflow: hidden;
`;

const HeaderContainer = styled.header`
  height: ${HEADER_CONTAINER_HEIGHT}px;
  ${cssClearFix}
  margin: 0 12px 3px 8px;
  display: flex;
  overflow: hidden;
`;

const POIcon = styled.img`
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;

const Icon = styled.img`
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 4px;
  ${({ cssExt }) => cssExt && cssExt}
`;

const FileNameWrapper = styled.div`
  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  //line-height: 1;
  letter-spacing: normal;
  color: #2f3133;
  margin: 0;
  height: 16px;
  display: flex;
  align-items: center;
  overflow: hidden;
`;

const FileName = styled.span`
  text-overflow: ellipsis;
  white-space: pre;
  overflow: hidden;
  align-self: flex-end;
`;

const SavedNoti = styled.span`
  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #2f3133;
  white-space: pre;
`;

const MenuName = styled.p`
  font-size: 13px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #2f3133;
  margin: 0;
  height: 18px;
  display: flex;
  align-items: center;
`;

const RenameIcon = styled.img`
  width: 8px;
  height: 5px;
  margin-left: 7.7px;
  &:hover {
    cursor: pointer;
  }
`;

const MacOSTabArea = styled.div`
  height: 31px;
  padding: 3px 0px 0px 17px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
`;

const MacOSTabMenu = css`
  min-width: 34px;
  border: none;
  width: 40px;
  height: 28px;
  font-size: 12px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  color: #2f3133;
  padding: 0;
`;

function Header({ editMode, setShowDialog }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const onClick = (dialogType, from) => {
    dispatch(openDialog({ dialogType, arg: { from } }));
  };

  const uploadItt = useUploadItt();
  const docInfo = useDocInfoSliceSelector();
  const appData = useAppDataSliceSelector();
  const isPCView = isDevicePC(appData.deviceType);
  const isUseExtFonts = getUseFonts();
  const doFlowByDownload = useDoFlowByDownload();

  const naverWorksData = useNaverWorksDataSliceSelector();

  const [checkUseFont, setCheckUseFont] = useState(isUseExtFonts);

  const editModeAll = Object.values(PO_EDIT_MODE);
  const prodTypeAll = Object.values(PRODUCT_TYPE);

  const excludeSpecificProdType = (prodType) => {
    return prodTypeAll.filter((item) => item !== prodType);
  };

  const isHWP = DOC_FORMAT_CONFIG_VALUES.sdk.documnetType === DOCUMENT_TYPE.HWP;

  const onSendNotice = useCallback(() => {
    ga.event({ category: '기타기능', action: '새소식' });
    window.open(URLS.NOTION.HOME, '_blank', 'noopener,noreferrer');
  }, []);

  const onClickUseFont = (event) => {
    setCheckUseFont(event.currentTarget.checked);
    setUseFonts(event.currentTarget.checked);
  };

  const onClickDownload = async () => {
    await doFlowByDownload(EDIT_FROM.FROM_HEADER, docInfo.fileName);
  };

  const onClickUserInfo = () => {
    onClick(DIALOG_TYPE.DIALOG_WHALESPACE_USERINFO);
  };

  const onClickUploadNaverWorksFile = async (driveType, driveId, folderId, fileId) => {
    dispatch(
      openDialog({
        dialogType: DIALOG_TYPE.DIALOG_UPLOAD_NAVERWORKS_FILE,
        arg: { driveType, driveId, folderId, fileId }
      })
    );
  };

  const headerMenuItems = [
    {
      id: 'MORE_FEATURES',
      supportEditMode: editModeAll,
      supportProdType: prodTypeAll,
      extConMode: [true, false],
      component: (
        <TitleMenuItem
          key={DIALOG_TYPE.DIALOG_INSTALL_DOCUMENT}
          onClick={() => onClick(DIALOG_TYPE.DIALOG_INSTALL_DOCUMENT, EDIT_FROM.FROM_HEADER)}>
          <Icon src={iconMore} srcSet={iconMore2X} />
          <MenuName>{t('Header.MoreFeatures')}</MenuName>
        </TitleMenuItem>
      )
    },
    {
      id: 'SAVE_FILE',
      supportEditMode: editModeAll,
      supportProdType: [PRODUCT_TYPE.WITH_WHALE_SPACE],
      extConMode: [true],
      component: (
        <TitleMenuItem
          key="Save File"
          onClick={() => {
            ga.event({ category: '문서 저장', action: '저장', label: '헤더' });
            dispatch(setMessage({ action: MESSAGE_TYPE.ACTION_TYPE.SAVE_FILE }));
          }}>
          <Icon src={iconDownload} srcSet={iconDownload2X} />
          <MenuName>{t('Common.DoSave')}</MenuName>
        </TitleMenuItem>
      )
    },
    {
      id: 'UPLOAD_NAVER_WORKS_FILE',
      supportEditMode: [PO_EDIT_MODE.EDIT],
      supportProdType: [PRODUCT_TYPE.WITH_WHALE_SPACE],
      extConMode: appData.productType === PRODUCT_TYPE.WITH_WHALE_SPACE ? [false] : [true, false], // defense extConMode=true only
      component:
        !appData.viaPartner && naverWorksData.isConnected ? (
          <TitleMenuItem
            key="Upload Naver Works File"
            onClick={() => {
              // ga.event({ category: '문서 저장', action: '저장', label: '헤더' });
              onClickUploadNaverWorksFile(
                naverWorksData.naverWorksFileInfo.driveType,
                naverWorksData.naverWorksFileInfo.driveId,
                naverWorksData.naverWorksFileInfo.folderId,
                naverWorksData.naverWorksFileInfo.fileId
              );
            }}>
            <Icon src={iconUploadWorks} srcSet={iconUploadWorks2X} />
            <MenuName>{t('Header.UploadNaverWorks')}</MenuName>
          </TitleMenuItem>
        ) : null
    },
    {
      id: 'UPLOAD_FILE',
      supportEditMode: [PO_EDIT_MODE.EDIT],
      supportProdType: [PRODUCT_TYPE.WITH_WHALE_SPACE],
      extConMode: [true, false],
      viaPartner: [appData.showUploadBtn === true ? VIA_PARTNER.ITT : null],
      component: (
        <TitleMenuItem key="Upload File" onClick={uploadItt}>
          <Icon src={iconUploadWorks} srcSet={iconUploadWorks2X} />
          {/* <Icon src={iconUpload} srcSet={iconUpload2X} /> */}
          <MenuName>{t('Header.Upload')}</MenuName>
        </TitleMenuItem>
      )
    },
    {
      id: 'DOWNLOAD_FILE',
      supportEditMode: editModeAll,
      supportProdType: prodTypeAll,
      extConMode: appData.productType === PRODUCT_TYPE.WITH_WHALE_SPACE ? [false] : [true, false], // defense extConMode=true only
      component: (
        <TitleMenuItem key="Download File" onClick={() => onClickDownload()}>
          <Icon src={iconDownload} srcSet={iconDownload2X} />
          <MenuName>{t('Header.Download')}</MenuName>
        </TitleMenuItem>
      )
    },
    {
      id: 'SHARE_LINK',
      supportEditMode: [PO_EDIT_MODE.EDIT],
      supportProdType: [PRODUCT_TYPE.STANDALONE, PRODUCT_TYPE.WITH_WHALE_SPACE],
      extConMode: [true, false],
      component: (
        <TitleMenuItem
          key="Share Link"
          onClick={() => onClick(DIALOG_TYPE.DIALOG_SHARE_LINK_DOCUMENT)}>
          <Icon src={iconShareLink} srcSet={iconShareLink2X} />
          <MenuName>{t('Header.ShareLink')}</MenuName>
        </TitleMenuItem>
      )
    },
    {
      id: 'NOTICE',
      supportEditMode: editModeAll,
      supportProdType: excludeSpecificProdType(PRODUCT_TYPE.WITH_WHALE_SPACE),
      extConMode: [true, false],
      component: (
        <TitleMenuItem key="Notice" onClick={onSendNotice}>
          <Icon src={iconNotice} srcSet={iconNotice2X} />
          <MenuName>{t('Header.Notice')}</MenuName>
        </TitleMenuItem>
      )
    },
    {
      id: 'USERINFO',
      supportEditMode: editModeAll,
      supportProdType: [PRODUCT_TYPE.WITH_WHALE_SPACE],
      extConMode: [true, false],
      component: (
        <TitleMenuItem
          key="UserInfo"
          onClick={onClickUserInfo}
          cssExt={css`
            padding: 0;
          `}>
          <Icon
            src={iconUser}
            srcSet={iconUser2X}
            cssExt={css`
              margin-right: 0;
              width: 18px;
              height: 18px;
            `}
          />
        </TitleMenuItem>
      )
    }
  ];

  const getSupportMenuItem = useCallback(
    () =>
      headerMenuItems
        .filter(
          (menu) =>
            menu.supportEditMode.includes(editMode) &&
            menu.supportProdType.includes(appData.productType) &&
            menu.extConMode.includes(appData.extensionConnectMode) &&
            (menu.viaPartner === undefined || menu.viaPartner.includes(appData.viaPartner))
        )
        .map((item) => {
          return item.component;
        }),
    [appData, editMode, docInfo, naverWorksData]
  );

  const onClickMobileDocumentDownload = () => {
    if (appData.isUnsupportDownload === true) {
      alert(t('Header.UnsupportDownload'));
    } else {
      onClick(DIALOG_TYPE.DIALOG_DOWNLOAD_DOCUMENT, EDIT_FROM.FROM_HEADER);
    }
  };

  const { formatIcon, formatIcon2x } = getFormatImg(DOC_FORMAT_CONFIG_VALUES.sdk.documnetType);
  const isShowMacMenu =
    isHWP && appData.clientOS === MAC_OS_NAME && isPCView && editMode === PO_EDIT_MODE.READ;

  return (
    <Fragment>
      {isPCView === true ? (
        <HeaderContainer>
          <TitleFileInfo>
            <POIcon src={formatIcon} srcSet={formatIcon2x} />
            <FileNameWrapper>
              <FileName>{docInfo.fileName}</FileName>
              {docInfo.isSaved && <SavedNoti> - {t('Header.SavedNoti')}</SavedNoti>}
            </FileNameWrapper>
            {editMode === PO_EDIT_MODE.EDIT && appData.extensionConnectMode !== true && (
              <RenameIcon
                src={iconRename}
                srcSet={iconRename2X}
                onClick={() => onClick(DIALOG_TYPE.DIALOG_FILE_RENAME)}
              />
            )}
          </TitleFileInfo>
          <TitleMenu>
            {/* <TitleMenuItem key="useFonts">
              <input
                type="checkbox"
                checked={checkUseFont}
                onChange={(event) => onClickUseFont(event)}
              />
              <MenuName>웹 폰트 사용</MenuName>
            </TitleMenuItem> */}
            {getSupportMenuItem()}
          </TitleMenu>
        </HeaderContainer>
      ) : (
        <HeaderMobile
          onClick={onClick}
          onClickMobileDocumentDownload={onClickMobileDocumentDownload}
        />
      )}
      {isShowMacMenu ? (
        <MacOSTabArea>
          <Button cssExt={MacOSTabMenu} onClick={() => dispatch(showFileMenu())}>
            {t('Header.File')}
          </Button>
        </MacOSTabArea>
      ) : null}
    </Fragment>
  );
}

export default Header;
